import { useEffect, useLayoutEffect, useState } from "react";
import { connect, useStore } from "react-redux";
import { Link, useHistory } from "react-router-dom";
import useMedia from "use-media";
import { apiKeyCheck, versionGetApi } from "../../../const";
import { useRtoaster } from "../../../hooks/useRtoaster";
import common from "../../../resources/RTCC/js/common/common";
import { Button } from "../../atoms/RTCC/button";
import './../../../resources/RTCC/css/passport/passport.css';
import { FooterContainer } from "./footerContainer";

const RtccInputPassportCompleteContainer = (props) => {

    //レスポンシブ対応
    const isWidePhone = useMedia({ maxWidth: '480px' });
    const isWideTablet = useMedia({ maxWidth: '960px' });
    const [Phone, setPhone] = useState(false);
    const [Tablet, setTablet] = useState(false);
    const useMediaFlag = useMedia({ maxWidth: '480px' });
    const [isMobilePhone, setIsMobilePhone] = useState(false);

    const history = useHistory();
    const store = useStore();

    // rtoasterタグ生成
    useRtoaster();

    useLayoutEffect(() => {
        // リフレッシュ対応
        let state = store.getState().login;
        let apiKey = null;
        if (Object.keys(state).length !== 0) {
            apiKey = state.apiKey;
        }
        if (apiKey === null) {
            store.dispatch({ type: "CLEAR_STATE" });
            history.push("/reserve/login");
        }
        if (apiKey) {
            common.doPost(apiKeyCheck, { apikey: apiKey }, afterApiKeyCheck);
        }
    })
    const afterApiKeyCheck = (res) => {
        if (!res.data) {
            console.log("バックからの戻り値false");
            store.dispatch({ type: "CLEAR_STATE" });
            history.push("/reserve/login");
        }
    }

    useEffect(() => {
        common.doPost(versionGetApi, {}, afterVerCheck);
        window.scroll({ top: 0, behavior: 'smooth' })
        if (useMediaFlag) {
            setIsMobilePhone(true);
        } else {
            setIsMobilePhone(false);
        }
    }, [useMediaFlag]);

    const afterVerCheck = (res) => {
        let flg = common.versionCheck(res.data.version);
        if (flg) {
            history.push("/reserve/login");
            return;
        }
    }

    // フライト情報登録ボタン押下時処理
    const onClickFlight = () => {
        history.push("/reserve/rtcc/inputFlight")
    }

    return (
        <div className="completeInnerWrapper">
            <div className="flightCompleteWrap">
                <div className="completeCheckImg"></div>
                <p className="completeTitle">パスポート情報の登録を承りました</p>
                <p style={isWideTablet ? styles.completeText2 : styles.completeText}>
                    ご利用いただき誠にありがとうございます。
                </p>
                <div className="completeButtonWrap">
                    <Button buttonText="フライト情報登録" className="completeButton" onClick={onClickFlight} buttonClassName="serachBtnText" />
                </div>
                <Link style={styles.link} to={"/reserve/rtcc/reservation"} >RTCC検索TOPへ戻る</Link>
            </div>
            <div style={styles.footer}>
                <FooterContainer className={"reservationResultFooterBase"} />
            </div>
        </div >
    );
};

const mapStateToProps = (state) => {
    return {
        checkIn: state.checkIn,
        group: state.group,
        room: state.room,
        human: state.human,
        course: state.course,
        detailCondition: state.detailCondition,
        startTime: state.startTime,
        login: state.login,
        kaiinken: state.kaiinken,
        area: state.area,
        country: state.country,
        city: state.city,
        checkIn: state.checkIn,
        toUserInputInfo: state.toUserInputInfo,
    };
};

const mapToDispatchToProps = (dispatch) => {
    return {
        setDetailCondition: (item) => {
            dispatch({ type: "DETAIL_CONDITION", payload: { detailCondition: item } })
        },
        setCourse: (item) => {
            dispatch({ type: "COURSE", payload: { course: item } })
        },
        setStartTime: (item) => {
            dispatch({ type: "START_TIME", payload: { startTime: item } })
        },
        setGroup: (item) => {
            dispatch({ type: "GROUP", payload: { group: item } })
        },
        setRoom: (item) => {
            dispatch({ type: "ROOM", payload: { room: item } })
        },
        setHuman: (item) => {
            dispatch({ type: "HUMAN", payload: { human: item } })
        },
        setSearchResult: (item) => {
            dispatch({ type: "SEARCH_RESULT", payload: item })
        },
        setKaiinken: (item) => {
            dispatch({ type: "KAIINKEN", payload: { kaiinken: item } })
        },
        setArea: (item) => {
            dispatch({ type: "AREA", payload: { area: item } })
        },
        setCountry: (item) => {
            dispatch({ type: "COUNTRY", payload: { country: item } })
        },
        setCity: (item) => {
            dispatch({ type: "CITY", payload: { city: item } })
        },
        setCheckIn: (item) => {
            dispatch({ type: "CHECKIN", payload: { checkIn: item } })
        },
        setToUserInputInfo: (item) => {
            dispatch({ type: "TO_USERINPUT_INFO", payload: { toUserInputInfo: item } })
        },
    };
}

export default connect(mapStateToProps, mapToDispatchToProps)(RtccInputPassportCompleteContainer);
const styles = {
    completeTitle: {
        textAlign: "center",
        fontSize: "1.1em",
    },
    completeText: {
        textAlign: "center",
        fontSize: "small",
    },
    completeText2: {
        textAlign: "center",
        fontSize: "0.7em",
    },
    base: {
        background: "rgba(255,255,255,0.9)",
        marginRight: "auto",
        marginLeft: "auto",
        width: "450px",
        padding: "40px",
    },
    base2: {
        background: "rgba(255,255,255,0.9)",
        marginRight: "auto",
        marginLeft: "auto",
        width: "calc(90% - 30px)",
        padding: "30px 15px",
    },
    box: {
        display: "inline-block",
        textAlign: "center",
        margin: "0px auto",
        width: "100%",
    },
    title: {
        fontSize: "20px",
        fontWeight: "bold",
        marginBottom: "25px",
    },
    link: {
        display: "block",
        padding: "3px",
        color: "#6f6f6f",
        textAlign: "center",
        fontSize: "small",
    },
    deletebr: {
        display: "none",
    },
    deletebr2: {
        display: "block",
    },
    btn: {
        display: "flex",
        textAlign: "center",
        backgroundColor: "black",
        color: "white",
        width: "60%",
        height: "40px",
        margin: "30px auto",
        border: "none",
        justifyContent: "center",
    },
    btn2: {
        display: "flex",
        textAlign: "center",
        backgroundColor: "black",
        color: "white",
        width: "100%",
        height: "40px",
        margin: "30px auto",
        border: "none",
        justifyContent: "center",
    },
    // btnImage: {
    //     width: "30px",
    //     height: "30px",
    //     backgroundImage: `url(${image_button})`,
    //     backgroundRepeat: "no-repeat",
    //     backgroundSize: "cover",
    //     backgroundPosition: "center",
    //     marginTop: "5px",
    // },
    useBtn: {
        textAlign: "center",
        backgroundColor: "black",
        color: "white",
        display: "inline-block",
        border: "none"
    },
    breadCrumb: {
        display: "flex",
        color: "white",
        marginLeft: "10%",
    },
    breadCrumbArrow: {
        marginRight: "16px",
        marginTop: "0px",
    },
    label: {
        textAlign: "left",
        width: "80%",
        padding: "4px 0px",
        fontWeight: "bold",
        color: "#6f6f6f",
        fontSize: "0.9rem",
        letterSpacing: "0.2rem"
    },
    label2: {
        textAlign: "left",
        width: "80%",
        padding: "4px 0px",
        fontWeight: "bold",
        color: "#6f6f6f",
        fontSize: 12.6,
        letterSpacing: "0.2rem"
    },
    inputLabel: {
        textAlign: "left",
        width: "80%",
        padding: "4px 0px",
        fontWeight: "bold",
        color: "#6f6f6f",
        fontSize: "0.9rem",
        letterSpacing: 3,
    },
    image: {
        width: 200,
        width: "40%",
        margin: "0 auto",
    },
    titleLabel: {
        fontSize: 16,
        letterSpacing: "0.2rem",
        color: "#6f6f6f",
    },
    titleLabel2: {
        fontSize: 14,
        letterSpacing: "0.2rem",
        color: "#6f6f6f",
    },
    form: {
        width: "60%",
        margin: "0px auto 50px",
    },
    line: {
        width: "100%",
        border: "1px solid rgb(204, 204, 204)",
        borderWidth: "1px 0px 0px 0px",
        margin: "45px auto 0px",
    },
    footer: {
        width: "80%",
        padding: "30px 10% 10px",
        whiteSpace: "nowrap",
        color: "white",
        fontWeight: "300",
    },
}